import { AttributionMode } from './attribution-bar-chart-enums';
export const ATTRIBUTION_MODE_LABELS = {
    [AttributionMode.RETURN]: 'Return',
    [AttributionMode.RISK]: 'Risk',
};
export const ATTRIBUTION_OPTIONS = [
    { label: ATTRIBUTION_MODE_LABELS[AttributionMode.RETURN], value: AttributionMode.RETURN, disabled: false },
    { label: ATTRIBUTION_MODE_LABELS[AttributionMode.RISK], value: AttributionMode.RISK, disabled: false },
];
